import React, { useState, useEffect, useRef } from 'react';

// Animated counter hook
function useCounter(target, duration = 2000, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (ts) => {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      // Ease out cubic
      const ease = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(ease * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [start, target, duration]);
  return count;
}

function StatItem({ value, suffix, label, icon, color, start }) {
  const num = useCounter(value, 2200, start);
  return (
    <div className="ls-item">
      <div className="ls-icon" style={{ background: `${color}18`, color }}>{icon}</div>
      <div className="ls-value" style={{ color }}>
        {num}{suffix}
      </div>
      <div className="ls-label">{label}</div>
    </div>
  );
}

const STATS = [
  { value: 50,  suffix: '+',  label: 'Projects Delivered', icon: '🚀', color: '#00B14F' },
  { value: 5,   suffix: '+',  label: 'Countries Served',   icon: '🌍', color: '#3B82F6' },
  { value: 100, suffix: '%',  label: 'Client Satisfaction',icon: '⭐', color: '#F59E0B' },
  { value: 3,   suffix: '',   label: 'SaaS Products',      icon: '📱', color: '#7C3AED' },
  { value: 40,  suffix: '%',  label: 'Avg Cloud Savings',  icon: '💰', color: '#10B981' },
  { value: 99,  suffix: '.9%',label: 'Uptime SLA',         icon: '⚡', color: '#EF4444' },
];

export default function LiveStats() {
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setStarted(true); obs.unobserve(el); }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="live-stats-sec" ref={ref} aria-label="Company statistics">
      <div className="wrap">
        <div className="ls-header rv">
          <div className="chip">📊 By The Numbers</div>
          <h2>Delivering Results That Matter</h2>
          <p>Real outcomes for real businesses — from Thanjavur to the world.</p>
        </div>
        <div className="ls-grid">
          {STATS.map(s => (
            <StatItem key={s.label} {...s} start={started} />
          ))}
        </div>
      </div>
    </section>
  );
}
